export const enum ConversionDalNamespaces {
    structure = 'structure',
    virtualStructure = 'virtualStructure',
    measurements = 'measurements',
    sourceLayout = 'sourceLayout',
    targetLayout = 'targetLayout',
    style = 'style',
    innerElements = 'innerElements',
    transformations = 'transformations'
}

export const ConversionDalStructureNamespaces = [
    ConversionDalNamespaces.structure,
    ConversionDalNamespaces.virtualStructure
]
